import loginService from "../../services/login.service";
import router from "../../router";
import UserConst from "../../enums/user"
import { getLS, removeLS } from "../../utils/localStorage-utils";

const actions = {


    async handleLogin({ dispatch, commit }, {account, acl}) {
        let redirect = account.redirect;
        delete account.redirect;
        return await loginService.handleLogin(account).then(
            response => {
                if (response.data.success){
                    let user = getLS('userInfo');
                    user = JSON.parse(user);
                    if (user && user.id) {
                        dispatch("updateUserInfo", user, {root: true});
                        if (redirect){
                            location.href = redirect
                        }else {
                            if (user.auth_flg === UserConst.AUTH_FLG_ADMIN) {
                                acl.change('admin');
                                // Route to admin page home
                                router.push({path: '/admin'})
                            } else if (user.auth_flg === UserConst.AUTH_SYS_ADMIN) {
                                acl.change('sys_admin');
                                // Route to sys admin page home
                                router.push({path: '/shachi/dashboard'})
                            } else {// Route to user page home
                                router.push({path: '/'});
                            }
                            return Promise.resolve(response)
                        }
                    } else {
                        dispatch("alertError", response.data.message, { root: true });
                        return Promise.resolve(response)
                    }
                }else{
                    dispatch("alertError", response.data.message, { root: true });
                    return Promise.resolve(response)
                }
            },
            error => {
                const message = (error && error.data && error.data.message) || error.message;
                dispatch("alertError", message, { root: true });
            }
        );
    },

    async handleDeskTokenLogin({ dispatch, commit }, {account, acl}) {
        let redirect = account.redirect;
        delete account.redirect;
        return await loginService.loginByToken(account).then(
            response => {
                if (response.data.success){
                    let user = getLS('userInfo');
                    user = JSON.parse(user);
                    if (user && user.id) {
                        dispatch("updateUserInfo", user, {root: true});
                        if (redirect){
                            location.href = redirect
                        }else {
                            // Route to user page home
                            router.push({path: '/'});
                            return Promise.resolve(response)
                        }
                    } else {
                        dispatch("alertError", response.data.message, { root: true });
                        return Promise.resolve(response)
                    }
                }else{
                    dispatch("alertError", response.data.message, { root: true });
                    return Promise.resolve(response)
                }
            },
            error => {
                const message = (error && error.data && error.data.message) || error.message;
                dispatch("alertError", message, { root: true });
            }
        );
    },

    async logout({ dispatch, commit }) {
        return await loginService.logout().then(
            response => {
                return Promise.resolve(response)
            },
            error => {
                // dispatch("alertError", error, { root: true });
                return Promise.reject(false);
            }
        );
    },

    async handleShachihataDeskLogin({ dispatch, commit }) {
      let data = JSON.parse(getLS('postMessage'));
      let account = {
        login_id: data.id,
        password: data.password,
        remember_me: true,
      }
      await loginService.handleLogin(account);
      //Remove postMessage
      removeLS('postMessage');
    },

    async handleGetByUid({ dispatch, commit }) {
        return await loginService.getByUid().then(
            response => {
                return Promise.resolve(response.data)
            },
            error => {
                return Promise.resolve(false);
            }
        );
    },
}


export default {
    namespaced: true,
    actions,
}